import TermOfUse from "../../components/footer/TermOfUse";


const TermOfUseView = () => {

    return (
        <div className="term-of-use">
            <TermOfUse/>
        </div>
    );
};

export default TermOfUseView;